import React from "react";
import { InlineMath } from "react-katex";

const VARIANTS = [
  { a: -1.5, b: -3, point1: [-2, 0], point2: [0, -3] },
  { a: 2, b: -2, point1: [1, 0], point2: [0, -2] },
  { a: -0.5, b: 2, point1: [0, 2], point2: [4, 0] },
  { a: 1.5, b: -3, point1: [0, -3], point2: [2, 0] },
  { a: -2, b: 2, point1: [0, 2], point2: [1, 0] },
  { a: 0.5, b: 1, point1: [-2, 0], point2: [0, 1] },
  { a: -1, b: -2, point1: [-2, 0], point2: [0, -2] },
  { a: 1, b: 3, point1: [-3, 0], point2: [0, 3] },
];

export function getLinearGraphData(original) {
  return original ? VARIANTS[0] : VARIANTS[Math.floor(Math.random() * VARIANTS.length)];
}

export function slopeLatex(value) {
  return String(value)
    .replace("-1.5", "-\\frac{3}{2}")
    .replace("1.5", "\\frac{3}{2}")
    .replace("-0.5", "-\\frac{1}{2}")
    .replace("0.5", "\\frac{1}{2}");
}

export function renderLinearGraphContext({ includeAngle = false } = {}) {
  return <div style={{ display: "grid", gap: 8 }}>
    <div>
      Funkcja liniowa <InlineMath math="f" /> jest określona wzorem{" "}
      <InlineMath math="f(x)=ax+b" />, gdzie <InlineMath math="a" /> i{" "}
      <InlineMath math="b" /> są pewnymi liczbami rzeczywistymi.
    </div>
    <div>
      W kartezjańskim układzie współrzędnych <InlineMath math="(x,y)" /> przedstawiono
      fragment wykresu funkcji <InlineMath math="f" />. Każdy z punktów przecięcia wykresu
      funkcji <InlineMath math="f" /> z osiami układu współrzędnych ma obie współrzędne całkowite.
    </div>
    {includeAngle ? <div>
      Wykres funkcji <InlineMath math="f" /> jest nachylony do osi <InlineMath math="Ox" />{" "}
      układu współrzędnych pod kątem o mierze <InlineMath math={"\\alpha"} /> (zobacz rysunek).
    </div> : null}
  </div>;
}
